class RefiTrackPageview extends HTMLElement {
  connectedCallback() {
    this.pageDetails = {
      pagename: this.getAttribute('pagename'),
    };

    this.appendProps('start', 'completed');

    this.dispatchEvent(
      new CustomEvent('refi-track-pageview', {
        bubbles: true,
        composed: true,
        detail: this.pageDetails,
      }),
    );
  }

  appendProps(...props) {
    props.forEach(prop => {
      const val = this.getAttribute(prop);
      if (val) {
        this.pageDetails[prop] = val;
      }
    });
  }
}

export { RefiTrackPageview };
